var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "append-to-body": true,
        "close-on-click-modal": false,
        "show-close": true,
        title: _vm.$t("scripting.generateReturnCode"),
        visible: _vm.addDialog,
        width: "550px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.addDialog = $event
        },
        close: function ($event) {
          return _vm.resetForm("ruleForm")
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("customerManagements.site"),
                prop: "nextSiteId",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.ruleForm.nextSiteId,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "nextSiteId", $$v)
                    },
                    expression: "ruleForm.nextSiteId",
                  },
                },
                _vm._l(_vm.nextSiteList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("GlobalSetObj.licensePlateNumber"),
                prop: "vehicleNumber",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                    "remote-method": _vm.getVehicleNumber,
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.getVehicleNumber(_vm.ruleForm.vehicleNumber)
                    },
                  },
                  model: {
                    value: _vm.ruleForm.vehicleNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "vehicleNumber", $$v)
                    },
                    expression: "ruleForm.vehicleNumber",
                  },
                },
                _vm._l(_vm.vehicleNumberList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("el-form-item", [
            _c(
              "div",
              { staticStyle: { "text-align": "right" } },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.resetForm("ruleForm")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("roleManage.cancel")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleForm")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("roleManage.confirm")) + " ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }